import { Box } from '@mui/material';
import NumberFormat from 'react-number-format';
import { UseTableCellProps } from 'react-table';
import { Product } from 'shared/types';
import { compareToMarginFloor } from 'shared/utility';

export default function PercentColumn({ value, row, column }: UseTableCellProps<Product>) {
    const margin = Number(value * 100);
    const applyColor = compareToMarginFloor(margin, row.original.marginFloor);
    const notPriceChange = column.id !== 'priceChange'; // possibly move this to own component?

    const showColor = notPriceChange && applyColor;
    return (
        <Box
            width='50%'
            display='flex'
            justifyContent='center'
            alignItems='center'
            sx={showColor ? { borderRadius: 2.5, backgroundColor: 'primary.light' } : undefined}
        >
            <NumberFormat value={margin.toFixed(1)} displayType='text' thousandSeparator={true} suffix={'%'} />
        </Box>
    );
}
